// extracted by mini-css-extract-plugin
module.exports = {"separationLine":"separation-line_separationLine__1hODr"};